import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/components/layouts/CommonFooter/CommonFooter.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1934107898/src/apps/fanychance/src/components/layouts/CommonHeader/CommonHeader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/components/ui/DevelopmentBadge/DevelopmentBadge.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1934107898/src/apps/fanychance/src/components/ui/ResaleProhibited/ResaleProhibited.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1934107898/src/apps/fanychance/src/features/auth/components/MenuWrapper/MenuWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/features/notification/components/SiteNotification/SiteNotification.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1934107898/src/apps/fanychance/src/features/serialCode/components/SerialCodeModal/SerialCodeModal.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/styles/modules/utils.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/styles/modules/layout.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/node_modules/next/dist/client/link.js");
